import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {HttpService} from '../../../../../../core';


@Component({
  selector: 'app-agency-info',
  templateUrl: './agency-info.component.html',
  styleUrls: ['./agency-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AgencyInfoComponent implements OnInit, AfterViewInit {
  submitted: any;
  // agencyInfoForm: any;
  @ViewChild('searchInput') searchInput: ElementRef;

  displayedColumns = ['agency', 'agent', 'email', 'phone', 'action'];
  dataSource: any;
  total: any;
  page: any;
  pageSize = 10;

  isLoading: any;

  constructor(private fb: FormBuilder, private httpService: HttpService, private cdr: ChangeDetectorRef) {
    // this.agencyInfoForm = this.fb.group({
    //
    // })

    }

  ngOnInit(): void {


  }



  ngAfterViewInit(): void {
    this.getData(null);

    // fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
    //   map((event: any) => {
    //     this.isLoading = true;
    //     this.cdr.detectChanges();
    //     return event.target.value;
    //   }),
    //   debounceTime(500),
    //   distinctUntilChanged()
    // ).subscribe((text: any) => {
    //   console.log(text);
    //   if (text.length === 0) {
    //     this.isLoading = false;
    //     this.cdr.detectChanges();
    //     return;
    //   }
    // });
  }

  searchAgent(e?) {
    this.httpService.getAllAgent(e ? e.pageIndex : this.page, this.pageSize, this.searchInput.nativeElement.value).subscribe((res: any) => {
      console.log(res);
      this.page = res.data.pageable.pageNumber;
      this.total = res.data.totalElements;
      this.dataSource = res.data.content;
      this.cdr.detectChanges();
    });
  }




  getData(e?) {
    if (this.searchInput.nativeElement.value) {
      this.searchAgent(e);
    } else {
      this.httpService.getAllAgent(
        e ? e.pageIndex : 0,
        this.pageSize,
      ).subscribe((res: any) => {
        console.log(res);
        this.dataSource = res.data.content;
        this.total = res.data.totalElements;
        this.page = res.data.pageable.pageNumber;
        this.cdr.detectChanges();
      });
    }


  }

  chooseAgent(agentId) {
    console.log(agentId);
  }

}
